import React from 'react';
import { block } from 'bem-cn';
import { CategoryPropsType } from '../../types/category.type';

import Typography from '../Typography';

import './index.scss';

const b = block('feed-article');

export type FeedArticlePropsType = {
  id?: string;
  title: string;
  categories?: CategoryPropsType[];
  imageUrl: string;
  subtitle?: string;
  url?: string;
  publisherLogo?: string;
  premium?: boolean;
};

const FeedArticle = ({
  title,
  subtitle,
  imageUrl,
  url,
  publisherLogo,
  premium,
  categories,
}: FeedArticlePropsType) => {
  const getContent = () => (
    <>
      <div
        className={b('overlay')}
        style={{ backgroundImage: `url(${imageUrl})` }}
      >
        {(premium || (categories && categories.length > 0)) && (
          <div className={b('overlay-actions')}>
            <>
              {premium && <div className={b('overlay-actions-premium')} />}
              {!premium && <div />}
              {categories && categories.length > 0 && (
                <div className={b('overlay-actions-categories')}>
                  {categories.map((category) => (
                    <div
                      key={category.id}
                      className={`${b('overlay-actions-category')} ${b(
                        'overlay-actions-category',
                        category.name,
                      )}`}
                    />
                  ))}
                </div>
              )}
            </>
          </div>
        )}
      </div>
      <div className={b('footer')}>
        {(publisherLogo || subtitle) && (
          <div className={b('pre-title')}>
            {publisherLogo && <img src={publisherLogo} alt='' />}
            {subtitle && (
              <Typography
                component='h4'
                className={b('subtitle').toString()}
                variant={Typography.THEME.VARIANTS.CAPS_BIG}
              >
                {subtitle}
              </Typography>
            )}
          </div>
        )}

        <Typography
          component='h3'
          className={b('title').toString()}
          variant={Typography.THEME.VARIANTS.TITLE_NORMAL}
        >
          {title}
        </Typography>
      </div>
    </>
  );

  if (url) {
    return (
      <a href={url} target='_blank' rel='noopener noreferrer' className={b()}>
        {getContent()}
      </a>
    );
  }

  return <div className={b()}>{getContent()}</div>;
};

export default FeedArticle;
